export default __webpack_public_path__ + "static/collective-ai-fcf37535da87bcd35c9c46ace25ee601.png";